import React from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";

function OrganizacijaPravosudjaPM() {
  return (
    <>
      <Navbar />
      <Bredcom title="Početna" subtitle="Organizacija pravosudja" />
      <div className="container mt-4">
        <div className="row">
          <div className="col-md-8">
            <div className="content-container">
              <h2 className="section-title">Organizacija pravosuđa</h2>
              <p>
                <strong>Studijski program:</strong> Pravo
              </p>
              <p>
                <strong>Naziv predmeta:</strong> Organizacija pravosuđa
              </p>
              <p>
                <strong>Nastavnik:</strong>
              </p>
              <p>
                <strong>Status predmeta:</strong> Obavezan
              </p>
              <p>
                <strong>Broj ECTS:</strong> 7
              </p>
              <p>
                <strong>Uslov:</strong> nema
              </p>
              <h3>Cilj predmeta</h3>
              <p>
                Predmet ima za cilj da studenti prošire znanja iz oblasti
                organizacije kako domaćeg tako i međunarodnog pravosudnog
                sistema. To se naročito odnosi na nadležnosti, postupak i praksu
                pravosudnih organa. Odvijanje procesa unutar svih učesnika u
                pravosudnom sistemu i međusobna povezanost i međuzavisnost biće
                naročito naglašeni. Jedan od ciljeva je da studenti ravnomjerno
                proučavaju i tumače i teoriju i praksu kako domaću tako i
                međunarodnu uporednu. Studenti će se upoznati sa pravosudnim
                tijelima, njihovim nadležnostima i razviti analitičke i
                primjenjive sposobnosti.
              </p>
              <h3>Ishod predmeta</h3>
              <p>
                Nakon uspješno savladanog gradiva student će moći: definisati i
                objasniti institucije i profesije koje učestvuju u pravosudnom
                sistemu, objasniti aspekte nezavisnosti i nepristrasnosti
                pravosuđa, analizirati procesne norme i njihovu primjenu,
                ukazati na značaj pravosuđa u procesu evropskih integracija,
                opisati ulogu pravosuđa u ostvarivanju ljudskih prava i sloboda
                i zaštiti ličnih i državnih interesa, kao i da upoređuje i
                analizira domaću i međunarodnu sudsku praksu. Takođe, nivo
                znanja i vještina omogućiće studentima da kritički posmatraju
                stanje u pravosuđu kao i vještine obavljanja istraživanja iz ove
                oblasti.
              </p>
              <h3>Sadržaj predmeta</h3>
              <p>
                <strong>Teorijska nastava:</strong>
              </p>
              <ul className="values-section">
                <li>
                  Osnovni pojmovi pravosudnog organizacionog prava; mjesto
                  pravosuđa u sistemu državne vlasti; podjela vlasti i sudstvo
                </li>
                <li>
                  Podjela pravosuđa; sud kao dio pravosudnog sistema; tužilaštvo
                  kao dio pravosudnog sistema
                </li>
                <li>
                  Zaštitnik imovinsko-pravnih interesa Crne Gore; Ombudsman;
                  uloga notara i advokata u pravosudnom sistemu
                </li>
                <li>
                  Fizička i pravna lica u pravosudnom sistemu; stručna pravna
                  pomoć
                </li>
                <li>
                  Međunarodni sud pravde: Osnivanje; Izbor sudija; Organizaciona
                  struktura; Nadležnost; Postupak pred Međunarodnim sudom
                  pravde: Pokretanje postupka; Pismena i usmena faza postupka;
                  Postupak pred većima; Okončanje postupka
                </li>
                <li>
                  Evropski sud za ljudska prava: Osnovna načela postupka;
                  Podnosilac predstavke; Zastupnik pred Evropskim sudom za
                  ljudska prava
                </li>
                <li>
                  Međunarodni krivični sud: Osnivanje Međunarodnog krivičnog
                  suda; Osnovne odlike i osnovna načela postupka; Nadležnost
                  Međunarodnog krivičnog suda; Međunarodna saradnja i pravna
                  pomoć; Međunarodni krivični tribunali ad hoc karaktera;
                  Međunarodni sud za pravo mora
                </li>
              </ul>
              <p>
                <strong>Praktična nastava:</strong>
              </p>
              <ul className="values-section">
                <li>Analiza sudske prakse</li>
                <li>Debate</li>
                <li>Pisanje ugovora</li>
                <li>Razvijanje tehnika za zaključivanje ugovora</li>
                <li>Analiza sudske prakse</li>
                <li>
                  Analiza svakodnevnih situacija i pronalaženje modaliteta
                  njihovog rješavanja.
                </li>
              </ul>

              <h3>Metode izvođenja nastave</h3>
              <p>
                Osnovni oblici rada na predmetu su: predavanja i vježbe,
                samostalni rad (seminarski rad), terenska nastava, seminari i
                radionice, upoznavanje studenata sa praksom domaćih i
                međunarodnih sudova.
              </p>
              <h3 className="pt-20 pb-10">Plan rada</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Nedjelja</th>
                    <th>Fond časova</th>
                    <th>Sadržaj</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Pripremna</td>
                    <td>Upoznavanje, dogovor o radu i slično</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>I</td>
                    <td>4P + 1V</td>
                    <td>Osnovni pojmovi pravosudnog organizacionog prava</td>
                  </tr>
                  <tr>
                    <td>II</td>
                    <td>4P + 1V</td>
                    <td>
                      Mjesto pravosuđa u sistemu državne vlasti; podjela vlasti
                      i sudstvo
                    </td>
                  </tr>
                  <tr>
                    <td>III</td>
                    <td>4P + 1V</td>
                    <td>
                      Podjela pravosuđa; sud kao dio pravosudnog sistema;
                      tužilaštvo kao dio pravosudnog sistema
                    </td>
                  </tr>
                  <tr>
                    <td>IV</td>
                    <td>4P + 1V</td>
                    <td>
                      Zaštitnik imovinsko-pravnih interesa Crne Gore; Ombudsman
                    </td>
                  </tr>
                  <tr>
                    <td>V</td>
                    <td>4P + 1V</td>
                    <td>Uloga notara i advokata u pravosudnom sistemu</td>
                  </tr>
                  <tr>
                    <td>VI</td>
                    <td></td>
                    <td>Kolokvijum I</td>
                  </tr>
                  <tr>
                    <td>VII</td>
                    <td>4P + 1V</td>
                    <td>
                      Fizička i pravna lica u pravosudnom sistemu; stručna
                      pravna pomoć
                    </td>
                  </tr>
                  <tr>
                    <td>VIII</td>
                    <td>4P + 1V</td>
                    <td>
                      Međunarodni sud pravde: Osnivanje; Izbor sudija;
                      Organizaciona struktura; Nadležnost; Postupak pred
                      Međunarodnim sudom pravde
                    </td>
                  </tr>
                  <tr>
                    <td>IX</td>
                    <td>4P + 1V</td>
                    <td>
                      Pokretanje postupka; Pismena i usmena faza postupka;
                      Postupak pred većima; Okončanje postupka
                    </td>
                  </tr>
                  <tr>
                    <td>X</td>
                    <td>4P + 1V</td>
                    <td>
                      Evropski sud za ljudska prava: Osnovna načela postupka
                    </td>
                  </tr>
                  <tr>
                    <td>XI</td>
                    <td>4P + 1V</td>
                    <td>
                      Podnosilac predstavke; Zastupnik pred Evropskim sudom za
                      ljudska prava
                    </td>
                  </tr>
                  <tr>
                    <td>XII</td>
                    <td></td>
                    <td>Kolokvijum II</td>
                  </tr>
                  <tr>
                    <td>XIII</td>
                    <td>4P + 1V</td>
                    <td>
                      Međunarodni krivični sud: Osnivanje Međunarodnog krivičnog
                      suda; Osnovne odlike i osnovna načela postupka; Nadležnost
                      Međunarodnog krivičnog suda
                    </td>
                  </tr>
                  <tr>
                    <td>XIV</td>
                    <td>4P + 1V</td>
                    <td>Međunarodna saradnja i pravna pomoć</td>
                  </tr>
                  <tr>
                    <td>XV</td>
                    <td>4P + 1V</td>
                    <td>
                      Međunarodni krivični tribunali ad hoc karaktera;
                      Međunarodni sud za pravo mora
                    </td>
                  </tr>
                  <tr>
                    <td>XVI</td>
                    <td></td>
                    <td>Sveobuhvatni ispit</td>
                  </tr>
                  <tr>
                    <td>XVII</td>
                    <td></td>
                    <td>Ovjera semestra i upis ocjena</td>
                  </tr>
                  <tr>
                    <td>XVIII</td>
                    <td></td>
                    <td>Popravni ispitni rok</td>
                  </tr>
                </tbody>
              </table>
              <h3 className="pt-20 pb-10">Obaveze studenata</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Obaveze studenata</th>
                    <th>U toku nastave</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Obaveze studenata u toku nastave</td>
                    <td>
                      Studenti su obavezni da pohađaju nastavu, vježbe i ispite
                    </td>
                  </tr>
                  <tr>
                    <td>Konsultacije</td>
                    <td>
                      Konsultacije se održavaju sa nastavnikom i saradnikom
                      poslije časova
                    </td>
                  </tr>
                  <tr>
                    <td>Opterećenje studenata u časovima</td>
                    <td>
                      <table className="table table-bordered ofpep-section">
                        <thead>
                          <tr>
                            <th>Nedjeljno</th>
                            <th>U semestru</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Ukupno: 5 č / 3.45h</td>
                            <td>Ukupno: 90 č</td>
                          </tr>
                          <tr>
                            <td>Predavanja: 4 č / 3h</td>
                            <td>Nastava + završni ispit: 65 č</td>
                          </tr>
                          <tr>
                            <td>Vježbe: 1 č / 0.45h</td>
                            <td>Priprema i ovjera semestra: 10 č</td>
                          </tr>
                          <tr>
                            <td>Individualni rad:</td>
                            <td>Priprema i polaganje popravnog ispita: 15 č</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
              <h3 className="pt-20 pb-10">Ocjenjivanje</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Ocjena</th>
                    <th>Broj poena</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>A(odličan)</td>
                    <td>91-100</td>
                  </tr>
                  <tr>
                    <td>B(vrlo dobar)</td>
                    <td>81-90</td>
                  </tr>
                  <tr>
                    <td>C(dobar)</td>
                    <td>71-80</td>
                  </tr>
                  <tr>
                    <td>D(zadovoljava)</td>
                    <td>61-70</td>
                  </tr>
                  <tr>
                    <td>E(dovoljan)</td>
                    <td>51-60</td>
                  </tr>
                  <tr>
                    <td>F(nedovoljan)</td>
                    <td>0-50</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-md-4 pt-10">
            <aside className="sidebar-widget">
              <section
                id="custom_html-5"
                className="widget_text widget widget_custom_html"
              >
                <h2 className="widget-title">Zapratite nas</h2>
                <div className="textwidget custom-html-widget">
                  <div className="widget-social">
                    <a
                      href="https://www.facebook.com/fpebar.me"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      href="https://www.instagram.com/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                    <a
                      href="https://www.youtube.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-youtube" />
                    </a>
                    <a
                      href="https://www.tiktok.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on Tiktok"
                      title="Tiktok"
                    >
                      <i className="fab fa-tiktok" />
                    </a>
                    <a
                      href="https://www.linkedin.com/school/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on LinkedIn"
                      title="LinkedIn"
                    >
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </div>
                </div>
              </section>
              <section id="categories-1" className="widget widget_categories">
                <h2 className="widget-title">Korisni linkovi</h2>
                <ul>
                  <li className="cat-item cat-item-16">
                    <Link to="/o-fpep">O Fakultetu</Link>
                  </li>
                  <li className="cat-item cat-item-23">
                    <Link to="/akreditacija-fpep">Akreditacija FPEP-a</Link>
                  </li>
                  <li className="cat-item cat-item-18">
                    <Link to="/upis">Upis</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/cijene-studija">Školarina</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/erasmus">Erasmus+</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/projekti">Projekti</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/dom-studenata">Dom studenata</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/galerija">Galerija</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/novosti">Novosti</Link>
                  </li>
                </ul>
              </section>
              <section
                id="recent-posts-4"
                className="widget widget_recent_entries"
              >
                <h2 className="widget-title">Studijski programi</h2>
                <ul>
                  <li>
                    <span className="post-date">
                      <strong>Osnovne studije</strong> <br />
                    </span>
                    <Link to="/racunovodstvo-finansije-i-bankarstvo">
                      Računovodstvo, bankarstvo i finansije
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/menadzment">
                      Menadžment
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-osnovne">
                      Pravo
                      <br />
                    </Link>
                  </li>
                  <li>
                    <span className="post-date">
                      <strong>Master studije</strong> <br />
                    </span>
                    <Link to="/poslovna-ekonomija">
                      Poslovna ekonomija
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/ekonomija-javnog-sektora">
                      Ekonomija javnog sektora
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-master">
                      Pravo
                      <br />
                    </Link>
                  </li>
                </ul>
              </section>
            </aside>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default OrganizacijaPravosudjaPM;
